import { uuidv7 } from "uuidv7";

// generate a device identifier
let _device_identifier = localStorage.getItem("device_identifier")
if (_device_identifier === null) {
    _device_identifier = uuidv7() + '-' + Date.now()
    localStorage.setItem("device_identifier", _device_identifier)
}

export const device_identifier = _device_identifier
